import { put, call, takeEvery, all } from "redux-saga/effects";
import api from "../../client/utils/clientApiHelper";
import {
  GET_COMMON_DASHBOARD,
  ADD_APP_FAV,
  GET_NEWS_AND_ANNOUNCEMENT,
  UPLOAD_ATTACHMENTS,
} from "./types";

import * as commonDashboardActions from "./actions";
import { getFileName } from "utils";

function* getCommonDashboard(req: any): any {
  const response = {
    "favoriteApplication": [
      {
        "id": 1,
        "appId": "Order Management",
        "description": "Order Management",
        "category": "LEADR Apps",
        "tag": "Order Management",
        "applicationURL": "/OrderManagement",
        // "appIconBlobURL": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/Applications/OrderManagement.png", 
        "isFavorite": true
      }],
    "applications": [
      {
        "category": "LEADR APPS",
        "applications": [
          {
            "id": 1, "appId":
              "Order Management",
            "description": "Order Management",
            "category": "LEADR Apps",
            "tag": "Order Management",
            "applicationURL": "/OrderManagement",
            // "appIconBlobURL": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/Applications/OrderManagement.png",
            "isFavorite": true
          },
          {
            "id": 2,
            "appId": "Bulk Order Management",
            "description": "Bulk Order Management",
            "category": "LEADR Apps", "tag":
            "Bulk Order Management", 
            // "applicationURL": "https://brightview-bulkorder-dev.azurewebsites.net/Account/AccessDenied?ReturnUrl=%2FDashboard", "appIconBlobURL": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/Applications/BulkOrderManagement.png", 
            "isFavorite": false
          }, 
          { "id": 3, 
          "appId": "Fleet Order Management", 
          "description": "Fleet Order Management", 
          "category": "LEADR Apps", 
          "tag": "Fleet Order Management", 
          "applicationURL": "/FleetManagement", 
          // "appIconBlobURL": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/Applications/FleetOrderManagement.png", 
          "isFavorite": false 
        }
      ]
      },
      { 
        "category": "FINANCE", 
        "applications": [
          { 
            "id": 4, 
            "appId": "Administration", 
            "description": "Administration", 
            "category": "Finance", "tag": "Administration", 
            "applicationURL": "", 
            // "appIconBlobURL": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/Applications/Administration.png", 
            "isFavorite": false 
          }, 
          { 
            "id": 5, 
            "appId": "Budgeting", 
            "description": "Budgeting", 
            "category": "Finance", 
            "tag": "Budgeting", 
            "applicationURL": "", 
            // "appIconBlobURL": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/Applications/Budgeting.png", 
            "isFavorite": false
           }
          ] 
        },
    ]
  };
  yield put(commonDashboardActions.setCommonDashboardApps(response));
}

function* addFavoriteApp(req: any): any {
  try {
    const response = yield call(
      api.callUserPost,
      "applications/favourites",
      req.favApp
    );
    if (response === true) {
      yield put(commonDashboardActions.setAddFavApp(response));
    }
  } catch (error) { }
}

function* getNewsAndAnnouncementDetails(req: any): any {
  const response = { 
    "total": 8,
    "data": [
      { 
        "statusName": "Active", 
        "segmentName": "Maintenance", 
        "lastUpdated": "06/15/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 1, 
        "title": 
        "BrightView Helps Renovate Military Wall of Honor in Riverside, Calif", 
        "message": "<div><p>A Military Wall of Honor was recently rededicated in Riverside, Calif.,\r\n in time for Memorial Day following a monthslong makeover.\r\n BrightView was commissioned to refurbish the landscaping in front of the monument.</p></div>", 
        "segmentId": 1, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/NewsAndAnnouncements-1.png", 
        "startDate": "06/21/2022", 
        "endDate": "07/11/2022", 
        "statusId": 1 
      }, { 
        "statusName": "InActive", 
        "segmentName": "Community", 
        "lastUpdated": "06/15/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 2, 
        "title": "Welcome to Brightview", 
        "message": "<div><h2>Welcome to Brightview</h2></div>", 
        "segmentId": 2, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/NewsAndAnnouncements-2.png", 
        "startDate": "06/10/2022", 
        "endDate": "06/11/2022", 
        "statusId": 0 
      }, { 
        "statusName": "Active", 
        "segmentName": "Community", 
        "lastUpdated": "06/15/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 3, 
        "title": "Website contents template components", 
        "message": "<strong>sample message</strong>", 
        "segmentId": 2, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/NewsAndAnnouncements-3.png", 
        "startDate": "07/10/2022", 
        "endDate": "07/11/2022", 
        "statusId": 1 
      }, { 
        "statusName": "Active", 
        "segmentName": "Community", 
        "lastUpdated": "06/15/2022", 
        "lastUpdatedBy": 
        "Brighviewsqluser", 
        "id": 4, 
        "title": "Brightview Renovations", 
        "message": "<div>sample renovations</div>", 
        "segmentId": 2,
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/news1.jpg", 
        "startDate": "07/10/2022", 
        "endDate": "07/11/2022", 
        "statusId": 1 
      }, { 
        "statusName": "Active", 
        "segmentName": "Maintenance", 
        "lastUpdated": "06/15/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 5, 
        "title": "Test News and Announcements", 
        "message": "<div>Test news and announcements</div>", 
        "segmentId": 1, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/news2.png", 
        "startDate": "07/10/2022", 
        "endDate": "07/11/2022", 
        "statusId": 1 
      }, { 
        "statusName": "Active", 
        "segmentName": "Community", 
        "lastUpdated": "08/02/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 10, 
        "title": "BrightView Prepares for Major League Baseball�s Field of Dreams Sequel", 
        "message": "<p>BLUE BELL, Pa.--(BUSINESS WIRE)-- We built it and they�re coming� again! As anticipation builds for the encore to last year�s MLB at Field of Dreams game, BrightView (NYSE: BV), the Official Field Consultant of Major League Baseball, is deep in the thick of a Dyersville, Iowa cornfield fine tuning and carefully manicuring the major league field inspired by the beloved 1989 film.</p>", 
        "segmentId": 2, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/Field_of_Dreams_01_-_with_logo.jpg", 
        "startDate": "08/02/2022", 
        "endDate": "08/02/2022", 
        "statusId": 1 
      }, { 
        "statusName": "Active", 
        "segmentName": "Community", 
        "lastUpdated": "08/02/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 11, 
        "title": "BrightView Continues Electric Conversion of Fleet Vehicles with Deployment of 100 Chevrolet Bolt EUVs", 
        "message": "<p>BLUE BELL, Pa.--(BUSINESS WIRE)-- As part of its ongoing effort to convert its fleet of vehicles to electric, BrightView (NYSE: BV), the nation�s leading commercial landscaping company, today announced the purchase of 100 electric-powered Chevrolet Bolt EUVs that will be put into service across the country, beginning this month. With the deployment of these new cars, BrightView�s management fleet is now comprised of nearly 400 electric and hybrid vehicles.</p>", 
        "segmentId": 2, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/BrightView_Chevy_Bolt.jpg", 
        "startDate": "07/26/2022", 
        "endDate": "07/26/2022", 
        "statusId": 1 
      }, 
      { 
        "statusName": "Active", 
        "segmentName": "Community", 
        "lastUpdated": "08/02/2022", 
        "lastUpdatedBy": "Brighviewsqluser", 
        "id": 12, 
        "title": "BrightView Holdings, Inc. Announces Third Quarter Fiscal Year 2022 Earnings Release Date, Conference Call and Webcast", 
        "message": "<p>BLUE BELL, Pa.--(BUSINESS WIRE)-- BrightView Holdings, Inc. (NYSE: BV) will hold its third quarter fiscal year 2022 earnings conference call on August 4, 2022, at 10 a.m. EDT. A press release detailing the Company�s third quarter results will be issued prior to the call. Instructions to join the conference call are provided below:</p>", "segmentId": 2, 
        // "imageBlobUrl": "https://saordermanagementdevuse.blob.core.windows.net/leadr-images/CommonPortal/NewsAndAnnouncements/brview_walkins.jpg", 
        "startDate": "07/21/2022",
        "endDate": "07/21/2022", 
        "statusId": 1 
      }
      ] };
  yield put(commonDashboardActions.setNewsAndAnnouncementDetails(response));
}

function* uploadAttachments(req: any): any {
  try {
    let fileObjList = req.obj.formData;
    const list = req.obj.filteredList;
    const response = yield call(api.callAssetPost, "assets/upload/attachments", fileObjList);

    // Converting attachment URL to object
    const updatedResponse = response
      .map((x: string) => {
        const obj = list.find((y: any) => getFileName(x) === y.name);
        if (obj) {
          return {
            fileName: obj.name,
            mimeType: obj.type,
            attachmentUrl: x,
          };
        }

        return null;
      })
      .filter((x: any) => !!x);
    yield put(commonDashboardActions.toggleAttachmentsLoading(false));
    yield put(commonDashboardActions.setAttachments(updatedResponse));
  } catch (error) {
    yield put(commonDashboardActions.toggleAttachmentsLoading(false));
    yield put(commonDashboardActions.setAttachments([]));
  }
}

function* watchGetCommonDashboard() {
  yield takeEvery(GET_COMMON_DASHBOARD, getCommonDashboard);
  yield takeEvery(ADD_APP_FAV, addFavoriteApp);
  yield takeEvery(GET_NEWS_AND_ANNOUNCEMENT, getNewsAndAnnouncementDetails);
  yield takeEvery(UPLOAD_ATTACHMENTS, uploadAttachments);
}

export default function* combinedSaga() {
  yield all([watchGetCommonDashboard()]);
}
